import React from 'react';
import { auth } from "../../../../../services";
import { connect } from 'react-redux';
import { FormGroup, Label, Input, Form, Button, FormFeedback } from 'reactstrap';
import { changePassword, resetChangePassword } from "../../../../../Redux/Actions/EndUser/AuthActions";
import { validationService } from '../../../../../services/validation.service';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';


class ChangePassword extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            currentPasswordError: '',
            newPasswordError: '',
            confirmPasswordError: ''
        }
        this.submit = this.submit.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.reset !== this.props.reset) {
            if (this.props.reset) {
                this.setState({
                    currentPassword: '',
                    newPassword: '',
                    confirmNewPassword: ''
                })
                this.props.resetChangePassword(null);
            }
        }
    }

    handleInputChange = (event) => {
      const target = event.target;
      this.setState({ [target.name]: target.value });

      if (target.name === 'currentPassword')
        this.validateCurrentPassword(target.value);

      if (target.name === 'newPassword')
          this.validatePassword(target.value);

      if (target.name === 'confirmNewPassword')
          this.validateConfirmPassword(target.value);
    }

    validateCurrentPassword = (val) => {
        this.setState({ currentPasswordError: val ? '' : "Current Password is required"});
        return val ? true : false;
    }

    validatePassword = (val) => {
        var passwordValidation = `Passwords must be between 6 and 18 characters, 
                                    have at least one non-alphanumeric character, 
                                    one digit ('0'-'9'), 
                                    one uppercase ('A'-'Z'), and 
                                    one lowercase ('a'-'z').`;

        var validPassword = validationService.isValidPassword(val);

        if (validPassword && val == this.state.currentPassword) {
            validPassword = false;
            passwordValidation = 'New password must be different than the current password.';
        }

        this.setState({ newPasswordError: validPassword ? '' : passwordValidation});
        return validPassword;
    }

    validateConfirmPassword = (val) => {
        var validPassword = this.state.newPassword === val;
        this.setState({ confirmPasswordError: validPassword ? '' : "Passwords do not match!"});
        return validPassword;
    }

    submit = (event) => {
        event.preventDefault();
        if (auth.isAuthenticated() &&
            this.validateCurrentPassword(this.state.currentPassword) &&
            this.validatePassword(this.state.newPassword) &&
            this.validateConfirmPassword(this.state.confirmNewPassword)) {
            const { dispatch } = this.props;
            this.props.changePassword(this.props.email, this.state.currentPassword, this.state.newPassword);
        }
    }

    render() {
        return (
            <div className="change-password account-tab-content">
                <div>
                    <div>
                        <h1 className="pt-3 pb-3">Change Password</h1>
                        <Form className="edit-account-form card">
                            <FormGroup className="list-group-item">
                                <Label htmlFor="currentPassword">Current Password:</Label>
                                <Input 
                                    type="password" 
                                    name="currentPassword" 
                                    id="currentPassword" 
                                    value={this.state.currentPassword}
                                    minLength={6}
                                    maxLength={18}
                                    onChange={this.handleInputChange}
                                    invalid ={ this.state.currentPasswordError ? true : false }
                                    placeholder="Current Password" />
                                    <FormFeedback>{this.state.currentPasswordError}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="list-group-item">
                                <Label htmlFor="newPassword">New Password:</Label>
                                <Input 
                                    type="password" 
                                    name="newPassword" 
                                    id="newPassword" 
                                    value={this.state.newPassword}
                                    minLength={6}
                                    maxLength={18}
                                    onChange={this.handleInputChange}
                                    invalid ={ this.state.newPasswordError ? true : false }
                                    placeholder="New Password" />
                                    <FormFeedback>{this.state.newPasswordError}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="list-group-item">
                                <Label htmlFor="confirmNewPassword">Confirm New Password:</Label>
                            <Input 
                                    type="password" 
                                    name="confirmNewPassword"
                                    className="form-control" 
                                    id="confirmNewPassword" 
                                    value={this.state.confirmNewPassword}
                                    onChange={this.handleInputChange}
                                    invalid ={ this.state.confirmPasswordError ? true : false }
                                    placeholder="Confirm New Password" />
                                    <FormFeedback>{this.state.confirmPasswordError}</FormFeedback>
                            </FormGroup>
                            <div className="list-group-item">
                            {this.props.error ? <p className="text-danger m-2">{this.props.error}</p> : null}
                                <Button color="primary"
                                        className="btnPrimary" 
                                        onClick ={this.submit}
                                        block>
                                        {
                                        this.props.submitting 
                                        ? <SpanSpinner message="Updating..." />
                                        : <span>UPDATE</span>
                                        }
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { error, submitting, email, reset } = state.changePassword;
    return { email, submitting, error, reset };
  }

  export default connect(mapStateToProps, { changePassword, resetChangePassword })(ChangePassword);